import React, { Fragment } from 'react';
import About from '../../components/About/About';
import BackToTop from '../../components/BackToTop/BackToTop';
import ContactArea from '../../components/ContactArea';
import Hero from '../../components/Hero/Hero';
import Marquee from '../../components/Marque/Marque';
import Navbar from '../../components/Navbar/Navbar';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import LetsConnectSection from '../../components/LetsConnect/LetsConnectSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import { Element } from 'react-scroll'
import MediaSection from '../../components/Media/MediaSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/Footer/Footer';
import Pricing from '../../components/Pricing';
import ClosingStatement from '../../components/ClosingStatement/ClosingStatement';

const HomePage = () => {
    return (
        <Fragment>
            <Navbar />

            {/* Section 1 */}
            <Element name='home'>
                <Hero />
            </Element>

            {/* Section 2 */}
            <Element name='about'>
                <About />
            </Element>

            {/* Section 3 */}
            <Element name='blog'>
                <MediaSection />
            </Element>

            {/* Section 4 */}
            <Element name='service'>
                <LetsConnectSection />
            </Element>

            {/* Section 5 */}
            <Testimonial />

            {/* Section 6 */}
            <Element name='project'>
                <ProjectSection />
            </Element>

            {/* Section 7 */}
            <Element name='blogs'>
                <BlogSection />
            </Element>

            {/* Section 7 */}
            {/* <Marquee /> */}

            {/* <Pricing /> */}

            {/* Section 8 */}
            <Element name='contact'>
                <ContactArea />
            </Element>

            {/* Section 9 */}
            <ClosingStatement />

            <Footer />

            <BackToTop />
        </Fragment>
    )
};
export default HomePage;